
/**
 * rimpiazza il :uid dal url e imposta l'uid dato in iput
 * @param route
 * @param uid
 * @returns {*}
 */
export function setRouteUid(route, uid){
    return route.replace(":uid", uid);
}

/**
 * genera l'errore della richiesta axios da mostrare all'utente
 * @param e
 * @param t se passata, traduce l'errore con la chiave inviata dal server (campo key)
 * @returns {string|*}
 */
export function getRequestError(e, t){
    console.log(e);
    if(!e.response){
        return "Errore interno"
    }

    if (e.response.data.status >= 500) {
        return "Errore interno al server"
    } else {
        const {key, message, error} = e.response.data;
        if (t && key && t(key) !== key) return t(key);
        //il server lo manda senza chiave
        if (t && message === 'Coupon not found') return t('error_coupon_not_found');
        //mostro l'errore
        return message || error;
    }
}